module.exports = __webpack_public_path__ + "static/media/empty-info.5975b7db.png";